<template>
  <div
    :class="$style['breadcrumbs']"
    class="breadcrumbs"
  >
    <ul :class="$style['top']">
      <li
        v-for="(link, index) in breadcrumbs.top"
        :key="link.name"
        :class="$style['item-top-wrapper']"
      >
        <breadcrumbs-item
          :first="index === 0"
          :draw-arrow="index !== 0 && index < breadcrumbs.top.length - 1 || (index === 0 && breadcrumbs.top.length > 1)"
          :link="link"
        />
      </li>
    </ul>

    <ul
      v-if="breadcrumbs.bottom.length > 0"
      :class="$style['bottom']"
    >
      <li
        v-for="(link, index) in breadcrumbs.bottom"
        :key="link.name"
        :class="$style['item-bottom-wrapper']"
      >
        <breadcrumbs-item
          :first="index === 0"
          :draw-arrow="index !== 0 && index < breadcrumbs.bottom.length - 1 || (index === 0 && breadcrumbs.bottom.length > 1)"
          :link="link"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import BreadcrumbsItem from "./breadcrumbs-item";

export default {
  name: "DsBreadcrumbs",
  components: {
    BreadcrumbsItem
  },
  props: {
    breadcrumbs: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../scss/_variables.scss";
@import "../../../scss/_mixins.scss";

.breadcrumbs {
  line-height: 1.2em;
  li {
    color: $black-blue-color;
    display: flex;
    align-self: flex-start;
  }
}
.top {
  line-height: 40px;
  display: flex;
  align-items: center;
}
.bottom {
  display: flex;
  align-items: center;
  min-height: 1.75em;
}
.item-top-wrapper {
  @include fluid-font($font-large-size);
  @include mobile() {
    @include fluid-font($font-big-size);
  }
}
.item-bottom-wrapper {
  @include fluid-font($font-regular-size);
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-breadcrumbs/ds-breadcrumbs.vue